/* app/controls/control.flyout */

import $ from 'jquery';	

let $flyout;
let $flyoutToggle;

var module = {
	init: function () {
		// Find all toggles and bind click events
		$(document).on('click', '[data-flyout-toggle]', function () {
			const flyoutName = $(this).attr('data-flyout-toggle');
			const $flyout = $('[data-flyout="' + flyoutName + '"]');

			if ($flyout.length) {
				$flyout.toggleClass('is-active');
			}
		});
	},
}

export { module as Flyout };